import prickFingerLandscapeImg from "../../../assets/img/prick-finger-landscape.png"
import prickFingerLandscapeImgWebp from "../../../assets/img/prick-finger-landscape.webp"

const ImDaniel = () => (
    <section id="im-daniel">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-4 gg-bg-solid-green-light">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={prickFingerLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={prickFingerLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <h3 className="fw-bold mb-5">
                                I’m Daniel.<br />
                                And I was diagnosed with type 2 diabetes.
                            </h3>
                            <p>
                                Sounds like the start of a sad meeting, right?<br />
                                A room full of tired people, slouched in folding chairs, nodding at each other in silent defeat.
                            </p>
                            <p>But this… isn’t that.</p>
                            <p>
                                I’m not here to cry about it.<br />
                                I’m here to tell you why I’m not sad anymore.
                            </p>
                            <p>And why, if you stick with me, you won’t be either.</p>
                            <p>But first, let me take you back to the life I had before the finger pricks. The carb counting. The worry.</p>
                            <p>Back when I thought type 2 diabetes was something that happened to other people.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ImDaniel;